import styled, { css } from 'styled-components';

import { media } from '@theme/media';
import { CONTAINER_PADDING } from '@components/blocks/blocks.constants';

import { containerStyles } from '../blocks.styles';

export const Container = styled.div`
  ${containerStyles};
`;

const defaultHeaderStyles = css`
  font-weight: 500;
`;

export const H1 = styled.h1`
  ${defaultHeaderStyles};
  font-size: 58px;
  line-height: 0.9em;
  margin: 88px 0;
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 0;

  ${media.desktop} {
    margin: ${CONTAINER_PADDING * 2}px ${CONTAINER_PADDING * 1.5}px;
    font-size: 76px;
    line-height: 0.9em;
    letter-spacing: 0.02em;
  }
`;

export const H2 = styled.h2`
  ${defaultHeaderStyles};
  font-size: 58px;
  line-height: 1.05em;
  text-align: center;
  margin: 88px 0;

  ${media.desktop} {
    margin: ${CONTAINER_PADDING * 2}px ${CONTAINER_PADDING}px;
    font-size: 76px;
    letter-spacing: 1.52px;
  }
`;

export const H3 = styled.h3`
  ${defaultHeaderStyles};
  font-size: 18px;
  letter-spacing: 0;
  line-height: 1.4em;
  margin: 2.8em 0 1.4em;

  ${media.mobile} {
    font-size: 30px;
    line-height: 1.25em;
    font-weight: 500;
  }

  ${media.desktop} {
    line-height: 1.4em;
  }
`;

export const H4 = styled.h4`
  ${defaultHeaderStyles};
  font-size: 18px;
  letter-spacing: 0;
  line-height: 1.4em;
  margin-top: 2.8em;
  margin-bottom: 1.4em;
  text-transform: none;
  text-align: center;

  ${media.mobile} {
    font-size: 20px;
    line-height: 1.25em;
  }

  ${media.tablet} {
    line-height: 1.4em;
  }
`;

export const H5 = styled.h5`
  ${defaultHeaderStyles};
  font-size: 18px;
  letter-spacing: 0;
  line-height: 1.4em;
  margin-bottom: 1.4em;
  text-transform: none;
  margin-left: ${CONTAINER_PADDING * 1.5}px;

  ${media.mobile} {
    font-size: 20px;
    line-height: 1.25em;
  }

  ${media.tablet} {
    line-height: 1.4em;
  }
`;

export const H6 = styled.h6`
  ${defaultHeaderStyles};
  font-size: 18px;
  letter-spacing: 0;
  line-height: 1.4em;
  margin-top: 1.4em;
  margin-bottom: 0.7em;
  text-transform: none;

  ${media.mobile} {
    font-size: 20px;
    line-height: 1.25em;
  }

  ${media.tablet} {
    line-height: 1.4em;
  }
`;
